<template>
  <div class="prepare-exam">
    <div  class="ss-breadcrumb">
      <div  class="container-hts">
          <ul class="margin-0 p-0">
            <li><router-link to="/danh-sach-de-thi">Danh sách đề thi</router-link></li>
            <li >Soạn đề thi</li>
          </ul>
      </div>
    </div>
    <div class="prepare-exam__main">
      <div  class="container-hts">
        <form novalidate>
          <div class="row">
            <div class="col-lg-3">
              <Sidebar @onSubmit="handleSaveExam" />
            </div>
            <div class="col-lg-9">
              <ExamInfo v-if="indexQuestionWorking === -1" :isSubmit="isSubmit" />
              <QuestionDetail v-else-if="indexQuestionWorking > -1" />
              <p v-if="indexQuestionWorking === -1" class="secondary-color-txt font-sanpro-semibold display-block font-size-18">Xem trước</p>
              <div id="prepare_question_view">
                <QuestionView :class="{'out-layout': indexQuestionWorking > -1}" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Sidebar from './../_components/exam/Sidebar.vue'
import ExamInfo from './../_components/exam/ExamInfo.vue'
import { apiCreateExam, apiUpdateExam, apiDetailExam } from './../_api/exam'
import { STORE_KEY } from './../_store/constants'
import { getAuth } from "@/utils/jwt"
import QuestionDetail from './../_components/questions/QuestionDetail.vue'
import QuestionView from './../_components/questions/QuestionView.vue'

export default {
  name: 'ExamAdd',
  components: {
    Sidebar,
    ExamInfo,
    QuestionDetail,
    QuestionView
  },
  data () {
    return {
      isSubmit: false
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['examInfo', 'classesExam', 'questionList', 'questionDetail', 'indexQuestionWorking']),

    examId () {
      return parseInt(this.$route.params.id)
    },
    authInfo () {
      return getAuth()
    }
  },
  created () {
    this.initPage()
  },
  beforeDestroy () {
    this.acSetQuestionIndexWorking(-1)
    this.acSetListQuestions([])
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetExamPrepareInfo', 'acSetListQuestions', 'acSetQuestionIndexWorking']),

    initPage () {
      let self = this
      if (!self.examId || self.examId === 0) {
        let dataExamInfo = {
          schoolName: self.authInfo.schoolName,
          teacherName: `${self.authInfo.firstName} ${self.authInfo.lastName}`
        }
        self.acSetExamPrepareInfo(dataExamInfo)
      } else {
        apiDetailExam(self.examId).then(res => {
          if (res) {
            self.acSetExamPrepareInfo(res)
            self.acSetListQuestions(res.questions ? res.questions : [])
          }
        })
      }
    },

    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },

    async handleSaveExam () {
      let elImgFeature = document.getElementById('prepare_question_view')
      this.isSubmit = true
      this.setLoading(true)
      if (!elImgFeature || !this.examInfo.name || !this.examInfo.classId || !this.examInfo.timeToDo) {
        this.setLoading(false)
        return
      }
      let htmlString = elImgFeature.innerHTML
      htmlString = htmlString.replaceAll('<img data-cke-saved-src="', '<img style="max-width: 600px;height: auto;" data-cke-saved-src="')
      // let options = { type: "dataURL" }
      // let imageBase64 = await this.$html2canvas(elImgFeature, options)
      // imageBase64 = imageBase64.replace(BASE_64_DEFINE, '')
      let questionIds = []
      if (this.questionList && this.questionList.length > 0) {
        this.questionList.map(ques => {
          ques.questionId && ques.questionId > 0 && questionIds.push(ques.questionId)
        })
      }
      await this.acSetExamPrepareInfo({ ...this.examInfo, examTypeId: 1, questions: this.questionList, examHtml: htmlString })
      // console.log('AAAAAA: ', { ...this.examInfo, examTypeId:1, questions: this.questionList });
      if (!this.examInfo.examId || this.examInfo.examId === 0) {
        this.createExam()
      } else {
        this.updateExam()
      }
    },

    createExam () {
      let self = this
      apiCreateExam(this.examInfo).then(res =>{
        if (res && res.data && res.data.examId && !res.errors) {
          self.$toast.success('Tạo đề thi thành công!')
          self.$router.push({ name: "examAdd", params: {id: res.data.examId} })
        }
      }).finally(() => {
        self.isSubmit = false
        self.setLoading(false)
      })
    },

    updateExam () {
      let self = this
      apiUpdateExam(this.examInfo).then(res => {
        if (res && res.data && !res.errors) {
          self.$toast.success('Cập nhật đề thi thành công!')
        }
      }).finally(() => {
        self.isSubmit = false
        self.setLoading(false)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .out-layout {
    position: fixed;
    top: 0;
    left: 100%;
    width: 100%;
  }
</style>